export const locale = {
    lang: 'fr',
    data: {
        'App': {
            'NAME': 'Qualisys',
            'ADD': 'Ajouter',
            'NEXT': 'Suivant',
            'CLEAR': 'Effacer',
            'EDIT': 'Modifier',
            'DELETE': 'Supprimer',
            'SAVE': 'Enregistrer',
            'CANCEL': 'Annuler',
            'MSG-DELETE': 'Êtes-vous sûr de vouloir supprimer cet élément ?',
            'ACTION': 'Action',
            'EMPTY-MSG': 'Aucun enregistrement',
            'CONFIRM': 'Confirmer',
            'TITLE_WITHOUT_SAVING': 'Modifications non enregistrées',
            'QUIT': 'Quitter sans enregistrer',
            'DOWNLOAD': 'Télécharger',
            'INVALID-SIZE-MSG': 'La taille du fichier ne doit pas dépasser',
            'SUMMARY_ERROR': 'Erreur',
            'SUMMARY_WARNING': 'Attention!',
            'SUMMARY_SUCCESS': 'Succès',
            'MSG_ERROR_CREATE': 'Erreur de création',
            'MSG_ERROR_LOAD': 'Erreur de chargement',
            'MSG_ERROR_UPDATE': 'Erreur de mise à jour',
            'MSG_ERROR_DELETE': 'Erreur de suppression',
            'MSG_FORBIDDEN': 'Vous n\'êtes pas autorisés à réaliser cette action.',
            'MSG_ERROR_DELETE_FK': 'Impossible de supprimer cet élément car il est utilisé par d\'autres éléments.',
            'PrimeNGConfig': {
                'monthNames': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                'dayNamesMin': ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                "dateIs": "Date égal",
                "dateIsNot": "Date différent",
                "dateBefore": "Date avant",
                "dateAfter": "Date après",
                "clear": "Nettoyer",
                "apply": "Appliquer",
                "addRule": "Ajouter une règle",
                "removeRule": "Supprimer la règle",
            },
            'SEARCH': 'Rechercher...',
            'NEW': 'Nouveau',
            'DUPLICATE': 'Dupliquer',
            'COPY': 'Copie',
            'OF': 'sur',
            'ADD_CREATE': 'Ajouter et créer',
            'NONE': 'Aucun',
            'INVALID_EMAIL': 'L\'adresse e-mail n\'est pas valide !',
            'YES': 'Oui',
            'NO': 'Non',
            'PRINT': 'Imprimer',
            'monthNamesMin': ['JAN', 'FÉV', 'MAR', 'AVR', 'MAI', 'JUN', 'JUL', 'AOÛ', 'SEP', 'OCT', 'NOV', 'DÉC'],
            'CHANGER': 'Changer',
            'ANS': 'ans',
            'AN': 'an',
            'MONTHS': 'mois',
            'MONTH': 'mois',
            'JOURS': 'jour(s)',
            'JOUR': 'jour',
            'EXPORT': 'Exporter Excel',
            'IMPORT': 'Importer Excel',
            'IMPORT_TITLE': 'Import terminé',
            'IMPORT_MSG': 'L\'import est effectué avec succès!',
            'SIMPLE_DIALOG': {
                'NAME': 'Nom',
                'DESCRIPTION': 'Description'
            },
            'MSG_UNSAVED_FORM': 'Voulez-vous vraiment quitter sans enregistrer vos modifications ?',
            'POWERED_BY': 'Powered by',
            'ENTREPRISE': 'Sama Consulting',
            'MSG_ERROR_CONFLICT': 'Enregistrement existant!',
            'MSG_ERROR_INVALID_ROW_VERSION': 'Les données ont été modifiées par un autre utilisateur. Vous devez actualiser la page et refaire vos modifications.',
            'NO_VALUE_FOUND': 'Aucune valeur trouvée',
            'PUBLISH': 'Publier',
            'MSG_MAX_FILE_SIZE': 'Le fichier trop volumineux. Sa taille ne doit pas dépasser {{maxFileSize}} MB',
            'MSG_REQUIRED_FORM' : 'Veuillez remplir tous les champs obligatoires',
            'NB': 'Veuillez noter : ',
            'SELECTIONNEZ_FICHIER': 'Sélectionnez un fichier',
            'OK': 'Ok',
            'INFO': 'Info',
            'ATTENTION': 'Attention',
            'NoInternetConnection': 'Pas de connexion internet',
            'InternetReconnected': 'Connexion Internet rétablie'
        }
        
    }
};